import { Plot, PLOTLY_CONFIG_BASE } from "./plot";
import type { Score } from "@/lib/api/types";

type Props = { score: Score; height?: number };

const FAMILIES = [
  { key: "valuation_score", label: "Valuation" },
  { key: "quality_score", label: "Quality" },
  { key: "growth_score", label: "Growth" },
  { key: "momentum_score", label: "Momentum" },
  { key: "revisions_score", label: "Revisions" },
  { key: "risk_score", label: "Risk" },
  { key: "technical_score", label: "Technical" }, // G4
  { key: "sentiment_score", label: "Sentiment" }, // Phase 1
  { key: "attention_score", label: "Attention" }, // Phase 1
] as const;

export function SubScoreRadar({ score, height = 320 }: Props) {
  const values = FAMILIES.map((f) => {
    const raw = (score as unknown as Record<string, number | null>)[f.key];
    return raw ?? 0;
  });
  const labels = FAMILIES.map((f) => f.label);
  return (
    <Plot
      data={[
        {
          type: "scatterpolar",
          r: [...values, values[0]!],
          theta: [...labels, labels[0]!],
          fill: "toself",
          line: { color: "#3b82f6" },
          marker: { color: "#3b82f6" },
          hovertemplate: "%{theta}: %{r:.1f}<extra></extra>",
        } as never,
      ]}
      layout={{
        height,
        paper_bgcolor: "transparent",
        plot_bgcolor: "transparent",
        font: { family: "Inter, ui-sans-serif", color: "#9aa3ad", size: 11 },
        margin: { t: 20, r: 30, b: 30, l: 30 },
        polar: {
          bgcolor: "transparent",
          radialaxis: {
            visible: true,
            range: [0, 100],
            color: "#5e6772",
            gridcolor: "#1f252d",
            angle: 90,
            tickangle: 90,
          },
          angularaxis: {
            color: "#9aa3ad",
            gridcolor: "#1f252d",
          },
        },
        showlegend: false,
      }}
      config={PLOTLY_CONFIG_BASE}
      style={{ width: "100%" }}
    />
  );
}
